<template>
    <div class="pt-3 px-3">
        <h6
            style="font-family: MainFontBold, sans-serif;
            font-size: 16px;
            color: #2A2A2A;">
            Basic Details
        </h6>
        <b-form-group
            id="productNameGroup"
            label="Product Name"
            label-for="productName"
            class="secondary-label"
            :invalid-feedback="errorMessage('name')"
            :state="isValid('name')">
            <b-form-input 
                id="productName"
                type="text"
                maxlength="40"
                required
                :disabled="editingFromLocationsPage"
                v-model="values.name">
            </b-form-input>
        </b-form-group>
        <b-form-group
            id="descriptionGroup"
            label-for="description"
            :label="'Description ' + descriptionLabel"
            class="secondary-label"
            :invalid-feedback="errorMessage('description')"
            :state="isValid('description')">
            <b-form-textarea
                placeholder="Enter description"
                :rows="3"
                :max-rows="6"
                :maxlength="maxDescription"
                :disabled="editingFromLocationsPage"
                v-model="values.description">
            </b-form-textarea>
        </b-form-group>
        <b-form-group
            label="Product Variation"
            class="secondary-label mb-2">
            <b-form-radio-group
                v-model="values.product_variation">
                <b-form-radio value="simple" :disabled="origin === 'edit_product'">Simple</b-form-radio>
                <b-form-radio value="variable" :disabled="origin === 'edit_product'">Variable</b-form-radio>
            </b-form-radio-group>
        </b-form-group>
        <b-form-group
            label="Category"
            label-for="category_id"
            class="secondary-label mb-2"
            :invalid-feedback="errorMessage('category_id')"
            :state="isValid('category_id')">
            <ProductCategoryDropdown
                :selectedCategory="values.category_id"
                :isDisabled="editingFromLocationsPage"
                @setSelectedCategory="setSelectedCategory"
                :origin="origin" />
        </b-form-group>
        <template v-if="!branchesLoading && branches.length > 1">
            <BrandBranches
                @applyBrandsAndBranches="applyBrandsAndBranches"
                errorKey="branch_uuids" 
                :brandAndBranchUuids="brandAndBranchUuids"
                formGroupLabel="Tag to Brand & Branch"
                formGroupClass="secondary-label mb-2"
                isDropRight
                :isAllSelected="
                    origin === 'edit_product'
                        ? values.selected_all_brands_branches
                        : false
                "
            />
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ProductCategoryDropdown from "@/components/estore/ProductCategoryDropdown";
import BrandBranches from "@/components/store/BrandBranches";

export default {
    name: "ProductBasicDetails",
    props: ["values", "origin"],
    components: {
        ProductCategoryDropdown,
        BrandBranches
    },
    data() {
        return {
            maxDescription: 2500,
            initial_category: {
                value: null,
                text: "Select Category",
                disabled: true
            },
            category_options: [],
            brandAndBranchUuids: []
        };
    },
    computed: {
        ...mapState("estoreInventories", ["categories", "errors"]),
        ...mapState("estoreLocations", ["editingFromLocationsPage"]),
        ...mapState("branches", {
            branches: state => state.branches,
            branchesLoading: state => state.loading
        }),
        descriptionLabel: {
            get: function() {
                if (this.values.description != null) {
                    return (
                        this.values.description.length +
                        " / " +
                        this.maxDescription
                    );
                }
                return "0 / " + this.maxDescription;
            }
        },
        defaultBrandAndBranchUuids() {
            return this.branches.length === 1
                ? this.branches.map(({ uuid, brand_uuid }) => ({
                    branch_uuid: uuid,
                    brand_uuid,
                }))
                : [];
        }
    },
    watch: {
        "values.branch_uuids"(branchUuids) {
            const selectedBranches = this.branches.filter(({ uuid }) =>
                branchUuids.includes(uuid)
            );
            this.brandAndBranchUuids = selectedBranches.length
                ? selectedBranches.map(({ uuid, brand_uuid }) => ({
                      branch_uuid: uuid,
                      brand_uuid
                  }))
                : [];
        },
        branches(branches) {
            if (this.origin === "new_product") {
                this.values.branch_uuids = [];

                if (branches.length === 1) 
                    this.values.branch_uuids = [branches[0].uuid];
            }
        }
    },
    beforeDestroy() {
        this.values.category_id = null;
    },
    methods: {
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },
        setSelectedCategory(value) {
            this.values.category_id = value;
        },
        applyBrandsAndBranches(brandAndBranches, isAllStores) {
            if (isAllStores) {
                this.values.selected_all_brands_branches = true;
            } else {
                this.values.selected_all_brands_branches = false;
                this.values.branch_uuids = brandAndBranches.map(
                    ({ branch_uuid }) => branch_uuid
                );
            }
        }
    }
};
</script>
